<template>
    <div class="modal-consent">
        <div class="modal-consent__wrapper">
            <IconClose class="modal-consent__close close" @click="closeHandle(false)"></IconClose>
            <div class="modal-consent__container">
                <LogoSmall class="modal-consent__logo"></LogoSmall>

                <p class="modal-consent__text" v-html="text"></p>

                <InputCheckbox
                    class="modal-consent__checkbox"
                    :name="'consent'"
                    :label="checkboxLabel"
                    :data="consent"
                    @setCheckboxValue="changeConsent">
                </InputCheckbox>

                <button class="modal-consent__btn" :class="{'active' : consent }" @click="consentConfirm">Wyrażam zgodę i przechodzę dalej <IconArrowRight class="modal-consent__arrow"></IconArrowRight></button>
            </div>
        </div>
    </div>
</template>

<script>
import IconClose from "../elements/icons/IconClose.vue";
import IconArrowRight from "../elements/icons/IconArrowRight.vue";
import LogoSmall from "../elements/LogoSmall.vue";
import InputCheckbox from "../profile/InputCheckbox.vue";

export default {
    name: 'ModalConsent',
    components: {
        IconClose,
        IconArrowRight,
        LogoSmall,
        InputCheckbox
    },
    data() {
        return {
            consent: false,
            checkboxLabel: 'Potwierdzam że jestem osobą pełnoletnią',
            text: 'Wyrażam zgodę na przetwarzani danych moich dzieci, nad którymi sprawuje opiekę w ramach założonych profili dzieci w celach analitycznych i śledzenia zachowań dziecka w aplikacji Kraina ABC (czas spędzony w aplikacji, podjęte aktywności, statystyki w ujęciu dziennym i średnia tygodniowa) oraz w celach dostosowywania treści i ulepszania produktu przez Telewizją Polską S.A. niniejsza zgodę można odwołać w każdym czasie co nie wpływa na legalność przetwarzania danych przed jej wycofaniem. Szczegółowe informacje o celach i sposobach przetwarzania danych znajdują się w <a href="/polityka" target="_blank">Polityce Prywatności Krainy ABC.</a>',
        }
    },    
    methods: {
        closeHandle(value) {
            this.$emit("consentHandle", value);
        },
        consentConfirm() {
            if(this.consent) {
                this.$emit("consentHandle", true);
            }
        },
        changeConsent(value) {
            this.consent = value;
        }
    }
}
</script>
